import React, { useState } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

const CATS = ["Chemical/s Refund", "Pool Part/s Refund", "Spa Part/s Refund", "Labour Refund"];

// Legacy Form_POSRefund: pick what is being refunded, type the amount, press ENTER -> a negative REFUND line on the sale.
export default function RefundPopup({ onAdd, onClose }) {
  const [cat, setCat] = useState("");
  const [amt, setAmt] = useState("");
  const n = Number(amt);
  const enter = () => { if (cat && n > 0) onAdd(cat, Math.round(n * 100) / 100); };
  return createPortal(
    <div className="fixed inset-0 z-[120] bg-black/50 flex items-center justify-center p-4" onClick={onClose} data-testid="pos-refund-popup">
      <div className="relative w-full max-w-md rounded-md shadow-2xl border border-slate-400 bg-[#a9d18e] p-5 text-center" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} data-testid="pos-refund-close" className="absolute top-2 right-2 rounded p-1 hover:bg-white/40"><X className="h-4 w-4" /></button>
        <div className="mx-6 bg-[#ffff66] border border-slate-400 py-1"><span className="bg-[#3a3a3a] text-[#ffff66] font-black text-xl px-1">REFUND</span></div>
        <div className="mt-3 flex flex-col items-center gap-1.5">
          {CATS.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`pos-refund-cat-${c.split("/")[0].split(" ")[0].toLowerCase()}`}
              className={`w-52 rounded border py-2 text-[14px] font-bold shadow-sm transition-colors ${cat === c ? "bg-[#123a63] text-white border-[#123a63]" : "bg-gradient-to-b from-[#eef3ff] to-[#c9d6f5] border-[#8ea5d8] text-slate-800 hover:brightness-105"}`}>{c}</button>
          ))}
        </div>
        <p className="mt-4 font-black text-xl text-slate-900">REFUND AMOUNT</p>
        <input type="number" min="0" step="0.01" value={amt} onChange={(e) => setAmt(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") enter(); }}
          disabled={!cat} placeholder={cat ? "" : "Pick what is being refunded first"} data-testid="pos-refund-amount"
          className="mt-1 w-52 bg-[#ffff66] border border-slate-500 px-2 py-2 text-center text-xl font-black disabled:opacity-60 placeholder:text-[11px] placeholder:font-normal" />
        <p className="mt-2 text-[13px] font-bold text-slate-800">After entering the refund amount, press the "ENTER" button on the keyboard.</p>
        <button onClick={enter} disabled={!cat || !(n > 0)} data-testid="pos-refund-enter" className="mt-3 w-52 rounded bg-[#123a63] text-white font-black py-2 disabled:opacity-40 hover:bg-[#1a4f8a]">ENTER</button>
      </div>
    </div>,
    document.body
  );
}
